import { Grid } from '@mui/material'
import { FunctionComponent } from 'react'

import { SimpleContainerBox } from '../../../base/components/Container/SimpleBox'
import Breadcrumb from '../../../base/components/Template/Breadcrumb/Breadcrumb'
import { recetasRoutesMap } from '../recetasRoutes'
import RecetasListado from './listado/RecetaListado'

/**
 * Gestion o Recetas
 * @constructor
 */
const RecetasGestion: FunctionComponent = () => {
  return (
    <SimpleContainerBox maxWidth={'xl'}>
      <Breadcrumb routeSegments={[recetasRoutesMap.gestion]} />
      <Grid container spacing={2}>
        <Grid size={12}>
          <RecetasListado />
        </Grid>
      </Grid>
    </SimpleContainerBox>
  )
}

export default RecetasGestion
